<template minapp="mpx" xlang="wxml">
  <view>
    <explain isShowTabIcon="{{isShowTabIcon}}"  class="explain1" explainValue="{{explainValue1}}"></explain>
    <refund-table class="refund1" tableValue="{{tableValue1}}"></refund-table>
    <explain class="explain2" explainValue="{{explainValue2}}"></explain>
    <refund-table class="refund1" tableValue="{{tableValue2}}"></refund-table>
    <explain class="explain3" explainValue="{{explainValue3}}"></explain>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      isShowTabIcon:true,
      explainValue1: {
        title: '是否可以退票？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 开车前:可以直接在滴滴申请退票'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 开车后:不能退票。请到始发车站人工窗口改签至当天其他车次出行。若当天无可改车次，则该票作废'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '3. 开车后改签的车票，不支持办理退票'
                }
              ]
            }
          ]
        ],
        prompt: '注：取票后，只能到车站窗口办理退票。便捷购票如需退票需至车站窗口办理，不支持网上在线退票。'
      },
      tableValue1: {
        tabWidth:"180px",
        title: '退票手续费怎么收取？',
        tableth:[
          "申请退票距发车时间","退票手续费"
        ],
        tablelist: [
          {
            title: '8天及以上',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '无'
                  }
                ]
              }
            ]
          },
          {
            title: '48小时-7天(含)',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价 '
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '5%'
                  }
                ]
              }
            ]
          },
          {
            title: '24 小时-48 小时(不含)',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价 '
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '10%'
                  }
                ]
              }
            ]
          },
          {
            title: '不足 24 小时',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价 '
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '20%'
                  }
                ]
              }
            ]
          }
        ],
        tip: '注:手续费不足 2 元时，按 2 元收取',
        prompt: '距离开车7天及以内的车票，改签至8天及以上后退票收取5%的手续费\n改签或变更到站后，车票乘车日期在春运期间（1月26日至3月5日）的，退票按开车前不足24小时标准（按票面价格20%）核收退票费。'
      },
      explainValue2: {
        title: '退款何时到账？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1-15 个工作日，原路退回'
                }
              ]
            }
          ]
        ]
      },
      tableValue2: {
        tabWidth:"180px",
        title: '如何退票',
        tableth:[
          "申请退票距发车时间","退票方式"
        ],
        tablelist: [
          {
            title: '未发车且未取纸质车票',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '火车票订单中退票'
                  }
                ]
              }
            ]
          },
          {
            title: '已过发车时间',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '不可办理 '
                  }
                ]
              }
            ]
          },
          {
            title: '已取报销凭证',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '人工窗口办理退票'
                  }
                ]
              }
            ]
          },
          {
            title: '已线下或其他平台办理改签',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '人工窗口办理退票'
                  }
                ]
              },
            ]
          },
          {
            title: '“便捷购票”申请退票',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '人工窗口办理退票'
                  }
                ]
              },
            ]
          }
        ],
        tip: '注:人工窗口办理退票，请务必在发车前，持本人购票时使用的乘车人有效身份证件原件到车站售票窗口办理(若已取报销凭证，请带好纸质车票)'
      },
      explainValue3: {
        title: '退票时优先回收优惠券',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '如您购票后需对车票进行人为退改（含主动退票、改签退原票、高改低退差价等场景），无论部分退款或整单退款，平台均会优先回收您已使用的火车票优惠券后再为您退还余下实付票款金额。'
                }
              ]
            }
          ]
        ]
      },
    },
    mounted() {},
    computed: {},

    methods: {}
  })
</script>

<style scoped lang="stylus">
  .explain1
    margin-bottom 12px
  .explain2, .explain3
    margin 12px 0
  .refund1
    border-radius 8px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'refund-table': '@/components/ticket-guide/refund-table'
    }
  }
</script>